// extracted by mini-css-extract-plugin
module.exports = {"checkBoxWrapper":"CheckBox_checkBoxWrapper__o1Enf","label":"CheckBox_label__py4BK","checkbox":"CheckBox_checkbox__Qvtb8","checkmark":"CheckBox_checkmark__i70bt"};